// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ant-select-multiple .ant-select-selection-search{width:auto!important}", "",{"version":3,"sources":["webpack://./../src/kuika/data-entry/selectbox/selectbox.scss"],"names":[],"mappings":"AAAA,kDACE,oBAAA","sourcesContent":[".ant-select-multiple .ant-select-selection-search {\n  width: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
